import { ExternalLink } from '@client/shared-components/ExternalLink';
import React from 'react';

export const MarkdownLink = (props: { children: React.ReactNode; href?: string }) => {
  // nosemgrep
  return <ExternalLink href={props.href ?? ''}>{props.children}</ExternalLink>;
};
